import { render, staticRenderFns } from "./SettingDesktop.vue?vue&type=template&id=21a92518&scoped=true&"
import script from "./SettingDesktop.vue?vue&type=script&lang=js&"
export * from "./SettingDesktop.vue?vue&type=script&lang=js&"
import style0 from "./SettingDesktop.vue?vue&type=style&index=0&id=21a92518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a92518",
  null
  
)

export default component.exports